import * as i0 from '@angular/core';
import { input, Component, ChangeDetectionStrategy } from '@angular/core';
import { NgDocButtonIconComponent } from '@ng-doc/ui-kit/components/button-icon';
import { NgDocIconComponent } from '@ng-doc/ui-kit/components/icon';
let MagnifierControllerComponent = /*#__PURE__*/(() => {
  class MagnifierControllerComponent {
    constructor() {
      this.magnifier = input.required();
    }
    static {
      this.ɵfac = function MagnifierControllerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MagnifierControllerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MagnifierControllerComponent,
        selectors: [["ng-doc-magnifier-controller"]],
        inputs: {
          magnifier: [1, "magnifier"]
        },
        decls: 17,
        vars: 7,
        consts: [[1, "ng-doc-controls-row"], ["ng-doc-button-icon-raised", "", 1, "ng-doc-button-up", 3, "click", "rounded"], ["icon", "chevron-right"], ["ng-doc-button-icon-raised", "", 1, "ng-doc-button-zoom-in", 3, "click", "rounded"], ["icon", "zoom-in"], ["ng-doc-button-icon-raised", "", 1, "ng-doc-button-left", 3, "click", "rounded"], ["ng-doc-button-icon-raised", "", 1, "ng-doc-button-center", 3, "click", "rounded"], ["icon", "maximize"], ["ng-doc-button-icon-raised", "", 1, "ng-doc-button-right", 3, "click", "rounded"], ["ng-doc-button-icon-raised", "", 1, "ng-doc-button-down", 3, "click", "rounded"], ["ng-doc-button-icon-raised", "", 1, "ng-doc-button-zoom-out", 3, "click", "rounded"], ["icon", "zoom-out"]],
        template: function MagnifierControllerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function MagnifierControllerComponent_Template_button_click_1_listener() {
              return ctx.magnifier().incrementY(50);
            });
            i0.ɵɵelement(2, "ng-doc-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 3);
            i0.ɵɵlistener("click", function MagnifierControllerComponent_Template_button_click_3_listener() {
              return ctx.magnifier().zoom(200);
            });
            i0.ɵɵelement(4, "ng-doc-icon", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 0)(6, "button", 5);
            i0.ɵɵlistener("click", function MagnifierControllerComponent_Template_button_click_6_listener() {
              return ctx.magnifier().incrementX(50);
            });
            i0.ɵɵelement(7, "ng-doc-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 6);
            i0.ɵɵlistener("click", function MagnifierControllerComponent_Template_button_click_8_listener() {
              return ctx.magnifier().reset();
            });
            i0.ɵɵelement(9, "ng-doc-icon", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "button", 8);
            i0.ɵɵlistener("click", function MagnifierControllerComponent_Template_button_click_10_listener() {
              return ctx.magnifier().incrementX(-50);
            });
            i0.ɵɵelement(11, "ng-doc-icon", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 0)(13, "button", 9);
            i0.ɵɵlistener("click", function MagnifierControllerComponent_Template_button_click_13_listener() {
              return ctx.magnifier().incrementY(-50);
            });
            i0.ɵɵelement(14, "ng-doc-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "button", 10);
            i0.ɵɵlistener("click", function MagnifierControllerComponent_Template_button_click_15_listener() {
              return ctx.magnifier().zoom(-200);
            });
            i0.ɵɵelement(16, "ng-doc-icon", 11);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("rounded", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("rounded", false);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("rounded", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("rounded", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("rounded", false);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("rounded", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("rounded", false);
          }
        },
        dependencies: [NgDocButtonIconComponent, NgDocIconComponent],
        styles: ["[_nghost-%COMP%]{display:inline-flex;flex-direction:column;gap:var(--ng-doc-base-gutter)}[_nghost-%COMP%]   .ng-doc-controls-row[_ngcontent-%COMP%]{display:flex;gap:var(--ng-doc-base-gutter);justify-content:center}[_nghost-%COMP%]   .ng-doc-controls-row[_ngcontent-%COMP%]:first-child, [_nghost-%COMP%]   .ng-doc-controls-row[_ngcontent-%COMP%]:last-child{justify-content:flex-end}[_nghost-%COMP%]   button.ng-doc-button-up[_ngcontent-%COMP%]   ng-doc-icon[icon=chevron-right][_ngcontent-%COMP%]{transform:rotate(270deg)}[_nghost-%COMP%]   button.ng-doc-button-down[_ngcontent-%COMP%]   ng-doc-icon[icon=chevron-right][_ngcontent-%COMP%]{transform:rotate(90deg)}[_nghost-%COMP%]   button.ng-doc-button-left[_ngcontent-%COMP%]   ng-doc-icon[icon=chevron-right][_ngcontent-%COMP%]{transform:rotate(180deg)}"],
        changeDetection: 0
      });
    }
  }
  return MagnifierControllerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MagnifierControllerComponent };
